__turbopack_context__.v({
  "loading": "search-layout-module-scss-module__LwBl9W__loading",
  "mobile-nav": "search-layout-module-scss-module__LwBl9W__mobile-nav",
  "page": "search-layout-module-scss-module__LwBl9W__page",
  "transparent-header": "search-layout-module-scss-module__LwBl9W__transparent-header",
});
